export default {
  title: 'خرید',

  labels: {
    id: 'شناسه فاکتور',
    sourceInvoice: 'منبع',
    user: 'تامین کننده',
    date: 'تاریخ ثبت',
    storeroom: 'انبار',
    status: 'وضعیت',
    fullName: 'نام کامل',
    address: 'آدرس',
    orderDate: 'تاریخ سفارش',
    phoneNumber: 'شماره تماس',
    pre: 'پیش',
    note: 'توضیحات',
    tax: 'مالیات',
    taxPercent: 'درصد مالیات',
    totalDiscount: 'تخفیف کل',
    totalPrice: 'قیمت کل',
    finalPrice: 'قیمت نهایی',
    shipping: 'حمل و نقل',
    vatInc: 'با مالیات'
  },

  placeholders: {
    id: 'اتوماتیک'
  },

  table: {
    header: {
      id: 'شماره فاکتور',
      creator: 'ایجادکننده',
      user: 'تامین کننده',
      company: 'شرکت',
      province: 'استان',
      date: 'تاریخ',
      unitPrice: 'مبلغ واحد',
      totalDiscount: 'تخفیف',
      totalVat: 'مالیات',
      shipping: 'حمل و نقل',
      finalPrice: 'مبلغ نهایی',
      status: 'وضعیت',
      delete: 'حذف',
      restore: 'بازگردانی'
    }
  },

  lines: {
    table: {
      header: {
        delete: 'حذف',
        edit: 'ویرایش',
        storeroom: 'انبار',
        finalPrice: 'مبلغ نهایی',
        totalPrice: 'مبلغ کل',
        tax: 'مالیات',
        unitPrice: 'مبلغ واحد',
        discount: 'تخفیف کل',
        count: 'تعداد',
        variant: 'متغیر',
        name: 'کالا',
        barcode: 'بارکد',
        row: 'ردیف'
      }
    }
  },

  invoices: {
    title: 'فاکتورهای خرید',

    status: {
      all: 'همه',
      preInvoice: 'سفارش خرید',
      invoice: 'فاکتور خرید',
      receipt: 'رسید انبار',
      incomplete: 'ناتمام'
    },

    prompts: {
      confirm: {
        title: 'تایید افزودن فاکتور خرید',

        actions: {
          payment: 'تایید',
          cancel: 'انصراف'
        }
      },
      activeInvoiceExist: {
        actions: {
          confirm: 'وضعیت فاکتور تغییر کرد، ذخیره'
        }
      }
    },

    notifications: {
      quantity: 'موجودی کالاها کافی نیست!',
      dynamicQuantity: 'موجودی کالای {name} کافی نیست!',

      isExists: {
        message: 'تعداد این کالا اضافه شد',
        dynamicMessage: '{product} در لیست وجود دارد'
      },
      increaseCount: {
        message: 'تعداد این کالا اضافه شد',
        dynamicMessage: 'تعداد {product} اضافه شد'
      },
      productNotFount: 'کالایی با این بارکد پیدا نشد',
      activeRefundInvoiceExists: 'برای این فاکتور، فاکتور مرجوع {invoices} ثبت شده اند. ابتدا وضعیت این فاکتورها را به سفارش خرید تغییر دهید | برای این فاکتور، فاکتورهای مرجوع {invoices} ثبت شده اند. ابتدا وضعیت این فاکتورها را به سفارش خرید تغییر دهید',
      activeInvoicesExists: 'برای این فاکتور، فاکتور فروش {invoices} ثبت شده اند. ابتدا وضعیت این فاکتورها را به سفارش خرید تغییر دهید | برای این فاکتور، فاکتورهای مرجوع {invoices} ثبت شده اند. ابتدا وضعیت این فاکتورها را به سفارش خرید تغییر دهید',

      insert: {
        success: 'فاکتور با موفقیت ثبت شد',
        error: 'ثبت فاکتور با خطا همراه شد!'
      },

      edit: {
        success: 'فاکتور با موفقیت بروزرسانی شد',
        error: 'بروزرسانی فاکتور با خطا همراه شد!'
      },

      delete: {
        success: 'فاکتور با موفقیت حذف شد',
        error: 'حذف فاکتور خرید با خطا همراه شد'
      },

      restore: {
        success: 'فاکتور با موفقیت بازگردانی شد',
        error: 'بازگردانی فاکتور خرید با خطا همراه شد'
      },

      refreshStatus: {
        success: 'وضعیت فاکتور خرید با موفقیت برگردانده شد',
        error: 'برگرداندن وضعیت فاکتور خرید با خطا همراه شد'
      },

      parseError: {
        user: 'تامین کننده انتخاب نشده است!',
        lines: 'هیچ کالایی انتخاب نشده است!',
        storeroom: 'انبار انتخاب نشده است!',
        unitPrice: 'مبلغ کالا وارد نشده است!',
        invoiceNumber: 'این شماره فاکتور از قبل انتخاب شده است!',
        quantity: 'تعداد کالای انتخاب شده معتبر نیست!',
        noProductEnter: 'هیچ کالای انتخاب نشده است!'
      }
    },

    confirmations: {
      editIncomplete: {
        title: 'تائیدیه ویرایش فاکتور خرید ناتمام',
        body: 'در صورت ویرایش فاکتور خرید تمامی حواله های انبار تایید شده مربوط به فاکتور حذف خواهد شد. آیا اطمینان دارید؟'
      },
      delete: {
        title: 'تائیدیه حذف فاکتور خرید',
        body: 'در صورت حذف فاکتور خرید تمامی اسناد و حواله های انبار مربوط به فاکتور حذف خواهد شد. آیا اطمینان دارید؟'
      },
      deleteLine: {
        title: 'تائیدیه حذف موردی فاکتور خرید',
        body: 'آیا از حذف «{name}» از فاکتور خرید اطمینان دارید؟'
      },
      forceDelete: {
        title: 'تائیدیه حذف فاکتور خرید',
        body: 'در صورت حذف فاکتور خرید اطلاعات فاکتور قابل برگشت نیست. آیا اطمینان دارید؟'
      },
      forceUpdate: {
        title: 'تائیدیه ویرایش فاکتور خرید',
        body: 'شما در حال ویرایش کامل فاکتور هستید، در صورت تائید تمامی اسناد و حواله های مربوط به این فاکتور نیز ویرایش می شوند. آیا از ادامه فرآیند اطمینان دارید؟'
      }
    },

    list: {
      title: 'فاکتورهای خرید'
    },

    insert: {
      title: 'افزودن خرید',

      table: {

        header: {
          row: 'ردیف',
          code: 'کد',
          product: 'کالا',
          dynamic: 'متغیر',
          number: 'تعداد',
          unitAmount: 'مبلغ واحد',
          amount: 'مبلغ کل',
          store: 'انبار',
          action: '#'
        }
      }
    },

    invoice: {
      title: 'فاکتور خرید',
      dynamicTitle: 'فاکتور خرید شماره {invoiceId}',

      notifications: {
        insertReturnInvoiceError: 'حواله رسید انبار فاکتور خرید ثبت نشده است'
      },

      actions: {
        print: 'پرینت',
        back: 'بازگشت'
      },

      print: {
        preInvoice: 'سفارش خرید',
        invoice: 'فاکتور خرید',

        labels: {
          date: 'تاریخ',
          documentNumber: 'شماره ',
          shipFrom: 'تامین کننده',
          phone: 'تلفن',
          address: 'آدرس',
          note: 'توضیحات'
        }
      },

      logs: {
        title: 'لاگ های فاکتور خرید',
      }
    },

    edit: {
      title: 'ویرایش خرید',
      dynamicTitle: 'ویرایش خرید شماره {invoiceId}'
    },

    trash: {
      title: 'سطل زباله فاکتور خرید'
    },

    suggest: {
      title: 'پیشنهاد خرید',

      table: {
        header: {
          select: 'انتخاب',
          image: 'عکس',
          barcode: 'بارکد',
          code: 'کد',
          category: 'دسته بندی',
          name: 'عنوان',
          variant: 'متغیر',
          score: 'امتیاز',
          totalSold: 'فروش کل',
          saleInventory: 'موجودی'
        }
      }
    },

    refreshStatus: {
      title: 'برگرداندن وضعیت فاکتور خرید',

      labels: {
        description: 'درنظر داشته باشید که در صورت برگرداندن وضعیت فاکتور، کلیه اسناد و حواله های مربوط به هر وضعیت پاک می شود',
        accept: 'تائید',
        cancel: 'انصراف'
      }
    },

    activeInvoiceExist: {
      title: 'جهت اعمال تغییرات ابتدا باید وضعیت فاکتورهای زیر به سفارش خرید تغییر کند',

      table: {
        header: {
          id: 'شماره فاکتور',
          type: 'نوع',
          user: 'طرف حساب',
          date: 'تاریخ',
          status: 'وضعیت'
        }
      },

      invoiceTypes: {
        1: 'فروش',
        2: 'خرید',
        3: 'مرجوع فروش',
        4: 'مرجوع خرید'
      },
      warehouseConversion: 'تبدیلات'
    }
  },

  purchaseFlowProducts: {
    title: 'آیتم های فاکتور خرید',

    status: {
      all: 'همه',
      preInvoice: 'سفارش خرید',
      invoice: 'فاکتور خرید',
      receipt: 'رسید انبار',
      incomplete: 'ناتمام'
    },

    list: {
      title: 'آیتم های فاکتور خرید'
    }
  },

  returnInvoices: {
    title: 'فاکتورهای مرجوع خرید',

    status: {
      all: 'همه',
      preInvoice: 'پیش فاکتور مرجوع خرید',
      invoice: 'فاکتور موجوع خرید',
      receipt: 'خروج انبار',
      incomplete: 'ناتمام'
    },

    notifications: {
      noProductSelected: 'هیچ کالایی انتخاب نشده است',
      productsNotExisted: 'موجودی کالاهای انتخاب شده کافی نمی باشد',
      dynamicProductNotExisted: 'موجودی کالای {name} کافی نمی باشد',

      isExists: {
        message: 'تعداد این کالا اضافه شد',
        dynamicMessage: '{product} در لیست وجود دارد'
      },
      increaseCount: {
        message: 'تعداد این کالا اضافه شد',
        dynamicMessage: 'تعداد {product} اضافه شد'
      },
      productNotFount: 'کالایی با این بارکد پیدا نشد',

      insert: {
        success: 'فاکتور مرجوع خرید با موفقیت ثبت شد',
        error: 'ثبت فاکتور مرجوع خرید با خطا همراه شد'
      },

      edit: {
        success: 'فاکتور مرجوع خرید با موفقیت بروزرسانی شد',
        error: 'بروزرسانی فاکتور مرجوع خرید با خطا همراه شد'
      },

      delete: {
        success: 'فاکتور با موفقیت حذف شد',
        error: 'حذف فاکتور مرجوع خرید با خطا همراه شد'
      },

      restore: {
        success: 'فاکتور با موفقیت بازگردانی شد',
        error: 'بازگردانی فاکتور مرجوع خرید با خطا همراه شد'
      },

      refreshStatus: {
        success: 'وضعیت فاکتور مرجوع خرید با موفقیت برگردانده شد',
        error: 'برگرداندن وضعیت فاکتور مرجوع خرید با خطا همراه شد'
      },

      parseError: {
        user: 'تامین کننده انتخاب نشده است!',
        lines: 'هیچ کالایی انتخاب نشده است!',
        storeroom: 'انبار انتخاب نشده است!',
        unitPrice: 'مبلغ کالا وارد نشده است!',
        invoiceNumber: 'این شماره فاکتور از قبل انتخاب شده است!',
        quantity: 'تعداد کالای انتخاب شده معتبر نیست!'
      }
    },

    confirmations: {
      delete: {
        title: 'تائیدیه حذف فاکتور مرجوع خرید',
        body: 'در صورت حذف فاکتور مرجوع خرید تمامی اسناد و حواله های انبار مربوط به فاکتور حذف خواهد شد. آیا اطمینان دارید؟'
      },
      forceDelete: {
        title: 'تائیدیه حذف فاکتور مرجوع خرید',
        body: 'در صورت حذف فاکتور مرجوع خرید اطلاعات فاکتور قابل برگشت نیست. آیا اطمینان دارید؟'
      },
      forceUpdate: {
        title: 'تائیدیه ویرایش فاکتور مرجوع خرید',
        body: 'شما در حال ویرایش کامل فاکتور هستید، در صورت تائید تمامی اسناد و حواله های مربوط به این فاکتور نیز ویرایش می شوند. آیا از ادامه فرآیند اطمینان دارید؟'
      }
    },

    list: {
      title: 'فاکتورهای مرجوع خرید',

      table: {

        header: {
          number: 'شماره فاکتور',
          creator: 'ایجادکننده',
          user: 'طرف حساب',
          date: 'تاریخ ایجاد',
          totalPrice: 'مبلغ کل',
          status: 'وضعیت'
        }
      }
    },

    insert: {
      title: 'افزودن فاکتور مرجوع خرید',

      table: {

        header: {
          row: 'ردیف',
          code: 'کد',
          product: 'کالا',
          dynamic: 'متغیر',
          number: 'تعداد',
          unitAmount: 'مبلغ واحد',
          amount: 'مبلغ کل',
          store: 'انبار',
          action: '#'
        }
      }
    },

    invoice: {
      title: 'فاکتور مرجوع خرید',
      dynamicTitle: 'فاکتور مرجوع خرید شماره {invoiceId}',

      print: {
        preInvoice: 'سفارش مرجوع خرید',
        invoice: 'فاکتور مرجوع خرید',
      },

      logs: {
        title: 'لاگ های فاکتور مرجوع خرید',
      }
    },

    edit: {
      title: 'ویرایش فاکتور مرجوع خرید',
      dynamicTitle: 'ویرایش فاکتور مرجوع خرید شماره {invoiceId}'
    },

    trash: {
      title: 'سطل زباله فاکتور مرجوع خرید'
    },

    refreshStatus: {
      title: 'برگرداندن وضعیت فاکتور مرجوع خرید',

      labels: {
        description: 'درنظر داشته باشید که در صورت برگرداندن وضعیت فاکتور، کلیه اسناد و حواله های مربوط به هر وضعیت پاک می شود',
        accept: 'تائید',
        cancel: 'انصراف'
      }
    }
  },

  actions: {
    insert: 'افزودن',
    edit: 'ویرایش',
    filters: 'فیلترها'
  }
}
